import { createContext, useContext, useState } from 'react';

type CommandType = {
  status: 'pending' | 'success' | 'error';
  data?: any;
};

type CommandResponseContextType = {
  commandResponse: CommandType | null;
  setCommandResponse: (response: CommandType | null) => void;
};

const CommandResponseContext = createContext<
  CommandResponseContextType | undefined
>(undefined);

export const useCommandResponse = ():
  | CommandResponseContextType
  | undefined => {
  return useContext(CommandResponseContext);
};

export const CommandResponseProvider = ({
  children
}: {
  children: React.ReactNode;
}) => {
  const [commandResponse, setCommandResponse] = useState<CommandType | null>(
    null
  );

  return (
    <CommandResponseContext.Provider
      value={{ commandResponse, setCommandResponse }}
    >
      {children}
    </CommandResponseContext.Provider>
  );
};
